import { faArchive } from "@fortawesome/free-solid-svg-icons";
import type { FC } from "react";
import { useApi } from "../api/APIContext";
import { useApiCall } from "../api/api";
import type { Exam } from "../api/dto";
import { ModalFooter } from "../components/layout/ModalProvider";

export const ArchiveExamModal: FC<{ exam: Exam }> = (props) => {
  const { refreshAll } = useApi();
  const { archiveExam } = useApiCall();
  const confirm = async () => {
    await archiveExam(props.exam.id);
    await refreshAll();
  };
  return (
    <>
      <div>Je staat op het punt om het volgende examen te archiveren.</div>
      <div className={"font-semibold my-2"}>
        &middot; <span>{props.exam.name}</span>
      </div>
      <div>Je kunt het examen later weer terugzetten.</div>

      <ModalFooter text={"Archiveer"} icon={faArchive} onSubmit={confirm} />
    </>
  );
};
